<template>
  <div class="detail_card">
		<div class="detail_card-title">
		<div>{{title}}<slot name="left"></slot></div>
		<slot name="right"></slot>
		</div>
		<slot></slot>
  </div>
</template>

<script>
export default {
  props:{
		title:{
			type:String,
			default:""
		}
	}
}
</script>


<style lang="scss" scoped>
.detail_card{
	padding:26px;
	border-bottom:1px solid rgba(220,223,230,1);
	&:last-child{
		border: none;
	}
	.detail_card-title{
		padding-left: 10px;
		font-size: 16px;
		height: 18px;
    line-height: 18px;
		display: flex;
		margin-bottom: 20px;
		border-left: 5px solid #F0722B;
		display: flex;
		justify-content: space-between;
	}
}
</style>
